import Modal from '@mui/material/Modal';
import { twMerge } from 'tailwind-merge';

export const BasicModal = ({ children, open, onClose, className }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="h-dvh flex overflow-scroll p-4" onClick={onClose}>
        <div
          className={twMerge('m-auto', className)}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {children}
        </div>
      </div>
    </Modal>
  );
};
